import PublicReviewsList from "@/components/PublicReviewsList";

export default function PublicReviews() {
  return (
    <div className="min-h-screen" style={{ background: "#05060d" }}>
      <PublicReviewsList />
    </div>
  );
}
